// https://stackoverflow.com/a/11818658/1933131
export function toFixed(num, fixed) {
  return num
    .toString()
    .match(new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?'))[0];
}

// https://leancrew.com/all-this/2020/06/ordinal-numerals-and-javascript/
export function toOrdinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;

  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export const eqWithinTolerance = (num1, num2, tolerance) =>
  Math.round(num1 * 10 ** tolerance) === Math.round(num2 * 10 ** tolerance);
